/**
 * Runtime configuration, fixed at build time. The values come from
 * env.config.ts: Vite embeds them as `__APP_CONFIG__` (vite.config.ts `define`)
 * and the Jest setup provides the same global with test values.
 */
export interface AppConfig {
  BUILD_ENV: string
  API_ENDPOINT: string
  FIREBASE_CONFIG: {
    apiKey?: string
    authDomain?: string
    databaseURL?: string
    projectId?: string
    storageBucket?: string
    messagingSenderId?: string
    appId?: string
    measurementId?: string
  }
  VIMEO_CONFIG: {
    VIMEO_CLIENT_SECRET: string
    VIMEO_CLIENT_ID: string
    VIMEO_ACCESS_TOKEN: string
    VIMEO_API_URL: string
  }
  CLOUDINARY_RESOURCE_URI: string
  CLOUDINARY_NAME: string
  MEMBER_WEB_URL: string
  MEMBER_WEB_PROTOCOL: string
  CLOUDINARY_DATA_EXTRACTION_URL: string
  sentry: {
    dsn?: string
    environment?: string
    enabled?: string | boolean
  }
  DATA_EXTRACTION_URL: string
}

declare const __APP_CONFIG__: AppConfig

const appConfig: AppConfig = __APP_CONFIG__

export default appConfig
